import PropTypes from 'prop-types';

import FormItem from 'components/FormItem/FormItem';
import { checkIsPossibleInternationalPhoneNumber } from 'utils/phone';

import Contact from '../Contact';

const CONTACT_NUMBER_ALLOWED_CHARS_REGEX = /^[+0-9\s\-().]*$/;

const constructContactNumberRules = () => {
  return [
    {
      validator: (_, value) => {
        const countryCode = value && value.countryCode;
        const contactNumber = value && value.contactNumber;

        // Optional field: only validate when user provides a number.
        if (!contactNumber) {
          return Promise.resolve();
        }

        if (!CONTACT_NUMBER_ALLOWED_CHARS_REGEX.test(String(contactNumber))) {
          return Promise.reject(new Error('Please enter a valid contact number.'));
        }

        const isPossiblePhoneNumber = checkIsPossibleInternationalPhoneNumber({
          countryCallingCode: countryCode,
          nationalNumber: contactNumber
        });

        if (!isPossiblePhoneNumber) {
          return Promise.reject(new Error('Please enter a valid contact number.'));
        }

        return Promise.resolve();
      }
    }
  ];
};

const FormContact = ({
  name,
  label,
  options,

  isDisabled,

  extraRules = [],
  requiredErrorMessage,

  onChange,

  tooltipMessage,

  extraPropsInput,
  extraPropsSelection
}) => {
  const contactNumberRules = constructContactNumberRules();

  return (
    <FormItem
      name={name}
      label={label}
      requiredErrorMessage={requiredErrorMessage}
      extraRules={[...extraRules, ...contactNumberRules]}
      tooltipMessage={tooltipMessage}
    >
      <Contact
        isDisabled={isDisabled}
        options={options}
        onChange={onChange}
        extraPropsInput={extraPropsInput}
        extraPropsSelection={extraPropsSelection}
      />
    </FormItem>
  );
};

FormContact.propTypes = {
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  label: PropTypes.string,
  options: PropTypes.array.isRequired,

  extraRules: PropTypes.array,
  requiredErrorMessage: PropTypes.string,

  isDisabled: PropTypes.bool,

  tooltipMessage: PropTypes.string,

  onChange: PropTypes.func,

  extraPropsInput: PropTypes.object,
  extraPropsSelection: PropTypes.object
};

export default FormContact;
